var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.openPlayer}},[_c('video-player',{ref:"previewVideoPlayer",staticClass:"player-fit vjs-big-play-centered",attrs:{"options":_vm.playerOptions,"disablepictureinpicture":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }